import styled from 'styled-components';

import { apx, fontFamilySize, px } from '../../contrib/ui';

export const FooterStyled = styled.div`
  height: fit-content;
  background-color: white;

  .inner-wrapper {
    padding: ${apx(25)} ${px(10)} ${apx(35)} ${px(10)};
    max-width: var(--adminContentSize);
    margin: 0 auto;
    width: 100%;

    @media (min-width: 300px) and (max-width: 767px) {
      padding: calc(0.0694vw * 49) 10px calc(0.0694vw * 30) 10px;
    }

    .footer-admin-content {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      @media (min-width: 300px) and (max-width: 767px) {
        display: block;
      }

      .logo {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;
        padding-bottom: ${apx(14)};

        img {
          margin-left: ${px(10)};
          margin-right: ${px(10)};
        }

        .line {
          border-bottom: 1px solid var(--grey97);
          flex: 1;
          height: 1px;
          display: none;
        }

        @media (min-width: 300px) and (max-width: 767px) {
          margin: 0 auto;
          padding-bottom: 0;

          .line {
            display: block;
          }
        }
      }

      .buttons {
        display: flex;
        height: fit-content;
        color: var(--grey87);
        align-self: center;
        margin: 0 ${apx(-7)} 0 ${apx(-7)};

        @media (min-width: 300px) and (max-width: 767px) {
          justify-content: center;
        }

        .footer-button {
          height: ${apx(40)} !important;
          width: ${apx(186)} !important;
          color: var(--grey87) !important;

          ${fontFamilySize('Bold', 14)}
          letter-spacing: 0 !important;
          line-height: ${apx(18)} !important;
          text-align: center !important;
          border: ${apx(1)} solid #fff !important;
          margin: 0 ${apx(7)} !important;

          @media (min-width: 300px) and (max-width: 767px) {
            border: none !important;
          }

          &:hover {
            background: rgba(255, 255, 255, 0.1) !important;
          }
        }
      }
    }

    .copyright {
      border-top: ${apx(1)} solid var(--grey97);
      padding-top: ${apx(14)};
      ${fontFamilySize('Medium', 14)}
      color: var(--grey87);
      line-height: 1.07em;

      @media (min-width: 300px) and (max-width: 767px) {
        border: none !important;
        text-align: center;
      }
    }
  }
`;
